<template>
    <div style="background-color: #505b6d" class="font-normal p-2 flex w-full items-center flex">
        <div class="w-full mb-4">

            <select
                v-model="selectedType"
                class="w-full pl-3 mb-1 mt-2 text-base bg-white rounded h-10 flex-1 items-center"
            >
                <option value="sell">For Sale</option>
                <option value="rent">For Rent</option>
            </select>

            <autocomplete
                :items="locationData"
                @input="locationSearch"
                @selectedLocation="setLocation"
            />

            <select 
                v-for="(bmk, index) in data"
                v-model="selected[bmk.label]"
                :key="index"
                class="w-full pl-3 mb-1 mt-2 text-base text-white rounded h-10 flex-1 items-center"
                style="background-color: #707987"
            >
                <option value="" selected>{{ bmk.default }}</option>
                <option 
                    v-for="(options, index) in bmk.options"
                    :key="index"
                    :value="options.value"
                >
                    {{ options.title }}
                </option>
            </select>

            <input 
                type="text" 
                style="background-color: #707987"
                class="rounded w-full text-white text-base h-10 pl-3 mb-1 mt-2" 
                aria-label="maxprice" 
                v-model="maxPrice" 
                name="maxprice" 
                placeholder="Max. Price" 
                data-number-delimiter=","
            >

            <button 
                style="background-color: #b41819" 
                class="w-full mt-2 p-2 rounded text-white text-base"
                @click="getSearchUrl"
            >
                Search
            </button>
        </div>
    </div>
</template>

<script>

import { actions } from '../api/fetch';
import mockData from '../api/brk/data.json';
import autocomplete from './autocomplete.vue';

export default {
    name: 'buyRentKenya',
    components: {
        autocomplete
    },
    data() {
        return {
            data: {
                type: Array,
                default: () => [],
            },
            locationData: {
                type: Array,
                default: () => [],
            },
            selected: {
                category: "",
                bedrooms: "",
                bathrooms: "",
            },
            selectedType: 'sell',
            maxPrice: '',
            locationId: '',
            locationDepth: '',
        }
    },
    created() {
        this.data = mockData.data;
        this.locationData = [];
        this.locationSearch('home');
    },
    methods: {
        setLocation(val) {
            this.location = val.locationId;
            this.locationDepth = val.locationDepth;
        },
        locationSearch(val) {
            actions.getData(`https://www.buyrentkenya.com/api/v1/search-locations?q=${val}`).then((value) => {
                this.locationId = '';
                this.locationData = value.data;
            });
        },
        getSearchUrl() {
            const offerType = `offer_type=${this.selectedType}`;
            const location = this.location ? `&location_depth_${this.locationDepth}=${this.location}` : '';
            const category = this.selected.category ? `&category_id=${this.selected.category}` : '';
            const bedroom = this.selected.bedrooms ? `&bedroom_counts[0]=${this.selected.bedrooms}` : '';

            const searchParams = offerType + location + category + bedroom;

            actions.getData(`https://www.buyrentkenya.com/api/v1/seo-search-path?${searchParams}`).then((value) => {
                this.search(value.data.search_path);
            });
        },
        search(urlSegment) {
            var url = '';
            var queryString = '';

            if (this.selected.bathrooms) {
                queryString = queryString.concat(`?bathrooms=${this.selected.bathrooms}`);
            }
            if (this.maxPrice) {
                queryString = queryString ? queryString.concat(`&price_max=${this.maxPrice}`) : queryString.concat(`?price_max=${this.maxPrice}`);
            }

            url = `https://www.buyrentkenya.com${urlSegment}${queryString}`;
            window.open(url, '_blank');
        }
    },
}
</script>

<style scoped>
    @import '../assets/styles/output.css';
</style>